"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .volume-slider .ant-popover-inner-content {\n    padding: ", " 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Volume = void 0;

var icons_1 = require("@ant-design/icons");

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var styled_components_1 = require("styled-components");

var MediaPlaybackContext_1 = require("../MediaPlaybackContext");

var styled_1 = require("../styled");

var VolumeGlobalStyle = (0, styled_components_1.createGlobalStyle)(_templateObject(), function (props) {
  return props.theme['@size-xs'];
});

function Volume(_ref) {
  var compact = _ref.compact;

  var _ref2 = (0, MediaPlaybackContext_1.useMediaPlaybackContext)(),
      volume = _ref2.volume,
      setVolume = _ref2.setVolume;

  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(VolumeGlobalStyle, null), react_1.default.createElement(antd_1.Popover, {
    trigger: ['click'],
    placement: 'top',
    overlayClassName: 'volume-slider',
    content: react_1.default.createElement(antd_1.Slider, {
      vertical: true,
      min: 0,
      max: 1,
      value: volume,
      onChange: setVolume,
      step: 0.1,
      style: {
        height: 150
      },
      tooltipVisible: false
    })
  }, react_1.default.createElement(antd_1.Tooltip, {
    title: 'Volume',
    mouseEnterDelay: 1
  }, react_1.default.createElement(styled_1.ControlContainer, {
    compact: compact !== undefined
  }, react_1.default.createElement(icons_1.SoundOutlined, null)))));
}

exports.Volume = Volume;